module.exports = __webpack_public_path__ + "Multi-Loc-Card.png";